import React, { useState } from "react";
import TodoItem from "./TodoItem";

function TodoList({ todos, setTodos }) {
  const [newTodo, setNewTodo] = useState("");
  const [todoError, setTodoError] = useState("");
  const [selectionError, setSelectionError] = useState("");

  const namePattern = /^[\p{L}\p{N}'.-]+(?: [\p{L}\p{N}'.@-]+)* ?$/u;

  const formatName = (value) => {
    return value
      .toLowerCase()
      .replace(/ +/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const addTodo = () => {
    if (newTodo.trim().length === 0) {
      setTodoError("Add at least one subject.");
      return;
    }
    if (newTodo.length > 25) {
      setTodoError("Exceeds 25 characters.");
      return;
    }
    if (!namePattern.test(newTodo)) {
      setTodoError("Spl chars ' . @ - allows only");
      return;
    }
    if (todos.length >= 48) {
      setTodoError("Maximum 48 subjects");
      return;
    }

    const formattedTodo = formatName(newTodo);

    setTodos([
      ...todos,
      { id: todos.length + 1, text: formattedTodo, isEditing: false, checked: false },
    ]);
    setNewTodo("");
    setTodoError("");
  };

  const updateTodo = (id, text, isEditing = false) => {
    const formattedText = formatName(text);
    setTodos(
      todos.map((todo) =>
        todo.id === id
          ? { ...todo, text: isEditing ? todo.text : formattedText, isEditing }
          : todo
      )
    );
  };

  const deleteTodo = (id) => {
    setTodos(todos.filter((todo) => todo.id !== id));
  };

  const toggleCheckbox = (id) => {
    setTodos(
      todos.map((todo) =>
        todo.id === id ? { ...todo, checked: !todo.checked } : todo
      )
    );
  };

  const toggleSelectAll = () => {
    const allSelected = todos.every(todo => todo.checked);
    setTodos(todos.map(todo => ({ ...todo, checked: !allSelected })));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0px", maxWidth: "100%" }}>
      <h2 style={{ fontSize: "20px", color: "#6c63ff" }}>
        Enter Subjects or Edit Below
      </h2>

      {/* Input and Add Button */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          value={newTodo}
          onChange={(e) => {
            const formattedInput = formatName(e.target.value);
            setNewTodo(formattedInput);
            setTodoError("");
          }}
          placeholder="Add upto 48 Subjects"
          style={{
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
          }}
        />
        <button
          type="button"
          onClick={addTodo}
          style={{
            padding: "10px 10px",
            backgroundColor: "#6c63ff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Add Subjects
        </button>
      </div>

      {/* Error Messages */}
      {todoError && <p style={{ color: "red", fontSize: "14px" }}>{todoError}</p>}
      {selectionError && <p style={{ color: "red", fontSize: "14px" }}>{selectionError}</p>}

      {/* Select All Checkbox */}
      {todos.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '40px', marginBottom: '0px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={todos.every(todo => todo.checked)}
              onChange={toggleSelectAll}
              style={{ margin: '0', padding: '0', width: '15%' }}
            />
            <span style={{ width: '80%' }}>Select All</span>
          </label>
        </div>
      )}

      {/* Todos List */}
      <ul style={{ paddingLeft: "0px", listStyle: "none" }}>
        {todos.map((todo, index) => (
          <TodoItem
            key={todo.id}
            todo={todo}
            serial={index + 1}
            updateTodo={updateTodo}
            deleteTodo={deleteTodo}
            toggleCheckbox={toggleCheckbox}
          />
        ))}
      </ul>
    </div>
  );
}

export default TodoList;
